import axios from "axios"

const liveApiUrl = process.env.REACT_APP_LIVE_API_URL
const token = JSON.parse(localStorage.getItem("Token"))

export const LoginAPI = async payload => {
  try {
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(
      `${liveApiUrl}/api/parent-auth/login`,
      payload,
      {
        headers,
      }
    )
    return response
  } catch (error) {
    console.error("Error Gettting Dashboard Icons:", error)
    throw error
  }
}

export const ModuleAllowedApi = async () => {
  try {
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: token,
      "Cache-Control": "no-cache",
    }

    const response = await axios.get(
      `${liveApiUrl}/api/parent-auth/get-block-modules`,
      {
        headers,
      }
    )
    return response
  } catch (error) {
    console.error("Error Gettting Dashboard Icons:", error)
    throw error
  }
}
